import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { BASE_APP_URL, PHP_APP_URL } from '../apiConfig';
import { useAuth } from '../Contexts/AuthContext';

const Navbar = () => {
    const { user, permissions } = useAuth();
    const userRoles = user?.roles || [];

    const isInternalUser =
        user &&
        (userRoles.includes('super_admin') || userRoles.includes('customer_service')) &&
        permissions?.includes('manage_customers');

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100vh',
                width: 60,
                backgroundColor: '#090928',
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: 16,
                alignItems: 'center',
                cursor: 'pointer',
                zIndex: 1000,
            }}
        >
            {isInternalUser && (
                <>
                    <Tooltip title="Customers" placement="right" arrow>
                        <IconButton
                            component={Link}
                            to={`${PHP_APP_URL}/resources/customers`}
                            sx={{
                                color: 'white',
                                marginBottom: 2,
                                '&:hover': {
                                    color: '#00b8d4',
                                },
                            }}
                        >
                            <PersonIcon />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Dashboard" placement="right" arrow>
                        <IconButton
                            component={Link}
                            to={`${BASE_APP_URL}/customers/approval`}
                            sx={{
                                color: 'white',
                                marginBottom: 2,
                                '&:hover': {
                                    color: '#00b8d4',
                                },
                            }}
                        >
                            <DashboardIcon />
                        </IconButton>
                    </Tooltip>
                </>
            )}

            <Tooltip title="Create New Customer" placement="right" arrow>
                <IconButton
                    component={Link}
                    to={`${BASE_APP_URL}`}
                    sx={{
                        color: 'white',
                        marginBottom: 2,
                        '&:hover': {
                            color: '#00b8d4',
                        },
                    }}
                >
                    <PersonAddIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default Navbar;